import { IContentInfo } from './IContentInfo';
import { IUserInfo } from './IUserInfo';

export interface ISharerInfo extends IUserInfo {
  isDeleted: boolean;
}

export interface ISharedWithMeCustomViewInfo {
  id: string;
  isHidden: boolean;
  name: string;
  url: string;
}

export interface ISharedWithMeContentInfo extends IContentInfo {
  isShareActivityIconVisible: boolean;
  message: string;
  sharedAt: Date;
  sharer: ISharerInfo;
  isAccessDenied: boolean;
  customView?: ISharedWithMeCustomViewInfo;
  // When adding another property here, make sure to update the helper function below
}

// Extract out only the properties that are in IContentInfo
export function removeSharedWithMeSpecificData(item: ISharedWithMeContentInfo): IContentInfo {
  const {isShareActivityIconVisible, message, sharedAt, sharer, isAccessDenied, customView, ...rest} = item;
  return rest;
}
